<template>
  <button-base :borderRadius="'lg1'" :class="componentClasses" :type="'solid'" @click="clicked()">
    <icon-up-arrow-filled size="sm2"/>
    <text-body-regular :class="textClass" :weight="'extra-bold'" :lineHeight="'multi'">{{text}}</text-body-regular>
    <text-body-extra-small class="gc-button-sub-category__sub-text" :lineHeight="'multi'" v-if="hasSubText">{{subText}}</text-body-extra-small>
  </button-base>
</template>

<script>

import ButtonBase from '../../root/ButtonBase'
import TextBodyRegular from '../typography/TextBodyRegular'
import TextBodyExtraSmall from '../typography/TextBodyExtraSmall'
import IconUpArrowFilled from '../../root/icons/IconUpArrowFilled'

export default {
  name: 'ButtonSubCategory',
  components: {
    IconUpArrowFilled,
    TextBodyExtraSmall,
    TextBodyRegular,
    ButtonBase
  },
  props: {
    /**
     * The main text of the button
     */
    text: {
      default: ''
    },
    /**
       * The sub text of the button
       */
    subText: {
      default: ''
    },
    selected:{
      default:false
    },
    /**
       * The disabled state of the button
       */
    disabled: {
      default: false
    }
  },
  computed: {
    hasSubText: function () {
      return this.subText.replace(/\s/g, '') !== ''
    },
    textClass: function () {
      return {
        'gc-button-sub-category__text': true,
        'gc-button-sub-category__text--with-sub-text': this.hasSubText
      }
    },
    componentClasses: function () {
      return {
        'gc-button-sub-category': true,
        'gc-button-sub-category--disabled': this.disabled,
        'gc-button-sub-category--selected': this.selected,
        'gc-button-sub-category--with-sub-text': this.hasSubText
      }
    }
  },
  methods: {
    /**
       * function to emit the click event
       */
    clicked () {
      if (!this.disabled) {
        this.$emit('click')
      }
    }
  }
}
</script>

<style scoped></style>
